import React, { useState } from "react";
import contactImg from "../assets/images/contact/1.jpg";

const Contact = () => {
  const colors = {
    accent: "#b76e79", // Rose Gold / Dust Pink
    dark: "#1a1a1a",
    text: "#4a4a4a",
    border: "#d6bfae",
  };

  const [form, setForm] = useState({
    name: "",
    email: "",
    subject: "",
    message: "",
  });

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const phoneNumber = "917781855269";
    const text = `Hello,%0A
Name: ${form.name}%0A
Email: ${form.email}%0A
Subject: ${form.subject}%0A
Message: ${form.message}`;

    // Open WhatsApp link
    window.open(`https://wa.me/${phoneNumber}?text=${text}`, "_blank");

    // Refresh the page after submission
    window.location.reload();
  };

  return (
    <>
      <section
        className="relative min-h-screen flex items-center justify-center py-16 px-4 bg-cover bg-center bg-no-repeat"
        style={{ backgroundImage: `url(${contactImg})` }}
      >
        {/* Dark Overlay */}
        <div className="absolute inset-0 bg-black/40" />

        {/* Main Glass Container */}
        <div className="relative z-10 w-full max-w-5xl grid lg:grid-cols-5 bg-white/10 backdrop-blur-xl rounded-3xl overflow-hidden shadow-2xl border border-white/20">
          
          {/* LEFT SIDE: Contact Info */}
          <div className="lg:col-span-2 p-8 md:p-12 text-white bg-black/20 flex flex-col justify-between">
            <div>
              <h2 className="text-4xl font-light leading-tight mb-4">
                Let’s Begin Your <br />
                <span style={{ color: colors.accent, fontWeight: 600 }}>Journey</span>
              </h2>
              <p className="text-gray-200 font-light mb-10">
                Compassionate care and advanced fertility solutions tailored for you.
              </p>

              <div className="space-y-8">
                <div className="flex items-start gap-4">
                  <div className="p-2 rounded-lg bg-white/10">
                    <span className="text-xl">📞</span>
                  </div>
                  <div>
                    <p className="text-xs uppercase tracking-widest opacity-70">Call Us</p>
                    <p className="text-lg font-medium">+91 77818 55269</p>
                  </div>
                </div>

                <div className="flex items-start gap-4">
                  <div className="p-2 rounded-lg bg-white/10">
                    <span className="text-xl">📧</span>
                  </div>
                  <div>
                    <p className="text-xs uppercase tracking-widest opacity-70">Email Us</p>
                    <p className="text-sm md:text-base font-medium break-all">drvibhasingh.gynae@gmail.com</p>
                  </div>
                </div>

                <div className="flex items-start gap-4">
                  <div className="p-2 rounded-lg bg-white/10">
                    <span className="text-xl">📍</span>
                  </div>
                  <div>
                    <p className="text-xs uppercase tracking-widest opacity-70">Location</p>
                    <p className="text-lg font-medium">Shop No. 1 & 2, Deewan Plaza, Greater Noida W Rd, near Ace Divino, Sector 1, Aimnabad, Bisrakh Jalalpur, Greater Noida, Bisrakh Jalalpur, Uttar Pradesh 201318</p>
                  </div>
                </div>
              </div>
            </div>

            <div className="mt-12 pt-8 border-t border-white/10 italic text-sm opacity-60">
              Available for consultations Monday - Saturday.
            </div>
          </div>

          {/* RIGHT SIDE: Form */}
          <div className="lg:col-span-3 p-8 md:p-12 bg-white/90">
            <h3 className="text-2xl font-semibold mb-8" style={{ color: colors.dark }}>
              Send a Message
            </h3>

            <form onSubmit={handleSubmit} className="space-y-5">
              <div className="grid md:grid-cols-2 gap-5">
                <div className="flex flex-col">
                  <label className="text-xs font-bold mb-1 uppercase text-gray-400">Full Name</label>
                  <input
                    type="text"
                    name="name"
                    placeholder="Full Name"
                    value={form.name}
                    onChange={handleChange}
                    required
                    className="w-full p-3 bg-gray-50 border border-gray-200 rounded-xl outline-none focus:border-[#b76e79] transition-colors"
                  />
                </div>
                <div className="flex flex-col">
                  <label className="text-xs font-bold mb-1 uppercase text-gray-400">Email Address</label>
                  <input
                    type="email"
                    name="email"
                    placeholder="email@example.com"
                    value={form.email}
                    onChange={handleChange}
                    required
                    className="w-full p-3 bg-gray-50 border border-gray-200 rounded-xl outline-none focus:border-[#b76e79] transition-colors"
                  />
                </div>
              </div>

              <div className="flex flex-col">
                <label className="text-xs font-bold mb-1 uppercase text-gray-400">Subject</label>
                <input
                  type="text"
                  name="subject"
                  placeholder="How can we help?"
                  value={form.subject}
                  onChange={handleChange}
                  required
                  className="w-full p-3 bg-gray-50 border border-gray-200 rounded-xl outline-none focus:border-[#b76e79] transition-colors"
                />
              </div>

              <div className="flex flex-col">
                <label className="text-xs font-bold mb-1 uppercase text-gray-400">Message</label>
                <textarea
                  name="message"
                  placeholder="Tell us about your requirements..."
                  value={form.message}
                  onChange={handleChange}
                  required
                  className="w-full p-3 bg-gray-50 border border-gray-200 rounded-xl outline-none h-32 resize-none focus:border-[#b76e79] transition-colors"
                />
              </div>

              <button
                type="submit"
                className="w-full md:w-max px-10 py-4 mt-4 rounded-full font-semibold text-white shadow-xl hover:opacity-90 transition-all active:scale-95 flex items-center justify-center gap-2"
                style={{ backgroundColor: colors.accent }}
              >
                <span>Send via WhatsApp</span>
                <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M.057 24l1.687-6.163c-1.041-1.804-1.588-3.849-1.587-5.946.003-6.556 5.338-11.891 11.893-11.891 3.181.001 6.167 1.24 8.407 3.481 2.241 2.242 3.48 5.226 3.481 8.408-.003 6.557-5.338 11.892-11.893 11.892-1.99-.001-3.951-.5-5.688-1.448l-6.301 1.657zm6.205-3.551c1.551.921 3.111 1.408 4.739 1.408 5.428 0 9.846-4.417 9.848-9.847-.002-5.429-4.421-9.847-9.849-9.847-2.637 0-5.114 1.027-6.974 2.887-1.859 1.86-2.887 4.335-2.888 6.973-.001 1.741.5 3.424 1.446 4.878l-.11.162-1.011 3.693 3.784-.993.165-.098z" />
                </svg>
              </button>
            </form>
          </div>
        </div>
      </section>

      {/* ================= GOOGLE MAP SECTION ================= */}
      <section className="bg-[#fcfaf8] py-20 px-4 md:px-10">
        <div className="max-w-6xl mx-auto text-center mb-10">
          <h2 className="text-4xl font-serif text-[#1a1a1a] mb-4">
            Visit  it 
          </h2>
          <p className="text-[#5a5a5a]">
            Shop No. 1 & 2, Deewan Plaza, Greater Noida W Rd, near Ace Divino, Sector 1, Aimnabad, Bisrakh Jalalpur, Greater Noida, Bisrakh Jalalpur, Uttar Pradesh 201318
          </p>
        </div>

        <div className="max-w-6xl mx-auto rounded-3xl overflow-hidden shadow-2xl border border-[#f0e4d7]">
          <iframe
            title="Dr Vibha Singh   Location"
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3504.3190654843793!2d77.4385665752863!3d28.560180175704378!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390cef002b5b9175%3A0x7e05cdbeee25df46!2sDoctor%E2%80%99s%20Clinic%20%26%20Lab!5e0!3m2!1sen!2sin!4v1772429297512!5m2!1sen!2sin"
            width="100%"
            height="450"
            style={{ border: 0 }}
            allowFullScreen=""
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
            className="w-full"
          ></iframe>
        </div>
      </section>
    </>
  );
};

export default Contact;